import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { defaultBrand } from "@/config/brand";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BrandContext = createContext(defaultBrand);

const cssVarMap = {
  primary: "--primary",
  primaryForeground: "--primary-foreground",
  secondary: "--secondary",
  secondaryForeground: "--secondary-foreground",
  accent: "--accent",
  accentForeground: "--accent-foreground",
  success: "--success",
  successForeground: "--success-foreground",
  background: "--background",
  foreground: "--foreground",
};

function applyBrand(brand) {
  const root = document.documentElement;
  Object.entries(brand.colors || {}).forEach(([key, value]) => {
    if (cssVarMap[key]) root.style.setProperty(cssVarMap[key], value);
  });
  root.style.setProperty("--ring", brand.colors?.primary || "");
  document.title = "Ovolaay - Votre plateforme avicole au Mali";
  if (brand.faviconUrl) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = brand.faviconUrl;
  }
}

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(defaultBrand);

  useEffect(() => {
    applyBrand(defaultBrand);
    axios
      .get(`${API}/brand`)
      .then((res) => {
        setBrand(res.data);
        applyBrand(res.data);
      })
      .catch(() => {});
  }, []);

  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  return useContext(BrandContext);
}
